module.exports = __webpack_public_path__ + "img/second-page.29ea413d.svg";